import React, { Component } from 'react';
import './PassengersDesktop.css';
import PassengersListWrapper from '../../passengersList/PassengersListWrapper';
import PassengersController from '../PassengersScreenController';
import RouteTabs from '../../routeTabs/RouteTabs';
import PassengersDesktopProps from './PassengersDesktopProps';
import ClassNames from 'classnames';
import Dictionary from '../../../model/Dictionary';
import EditPassenger from '../common/editPassenger/EditPassenger';

export default class PassengersDesktopScreen extends Component {
  static propTypes = PassengersDesktopProps;

  constructor (props) {
    super(props);
    this.state = { editOpened: false, selectedPassenger: undefined };
    this.openEditPassenger = PassengersController.openEditPassenger.bind(this);
    this.closeEditPassenger = PassengersController.closeEditPassenger.bind(this);
  }

  render () {
    const { routeId, routes, selectedRoute, selectedTrip, toggleRoutes } = this.props;
    const { editOpened, selectedPassenger } = this.state;

    let mainContainerClass = ClassNames({
      'col-12': !editOpened,
      'col-8': editOpened,
      'full-height': true,
    });
    let editPassengerClass = ClassNames({ 'col-4': editOpened });
    return (
      <div className='row passengers'>
        <div className={mainContainerClass}>
          <h1>{Dictionary.passengers.title}</h1>
          <RouteTabs
            isMain
            showDate
            routes={routes}
            selectedTrip={selectedTrip}
            selectedRoute={selectedRoute}
            toggleRoutes={toggleRoutes}
            TabContent={
              <PassengersListWrapper
                routeId={routeId}
                onRowAction={this.openEditPassenger}
                selectable
                addNew
              />
            }
          />
        </div>
        {!editOpened ? null : (
          <div
            style={{
              padding: 0,
              borderLeft: '1px solid #dddfe4',
            }}
            className={editPassengerClass}
          >
            <EditPassenger
              handleClose={this.closeEditPassenger}
              selectedPassenger={selectedPassenger}
            />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/passengers/desktop/PassengersDesktopScreen.js